/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

'use strict';

angular.module('prism-ui.components').service('IntermediateTemplatesService', function (this: JS5Object, _: JS5Object, IntermediateTemplatesResourceFactory: JS5Object) {
    this.originalEditData = {};
    this.getAllIntermediateTemplates = (queryParams: JS5Object, queryHandler: JS5Function) => {
        return IntermediateTemplatesResourceFactory.query(queryParams, queryHandler).$promise;
    };
    this.getIntermediateTemplate = (intermediateTemplateId: number) => {
        return IntermediateTemplatesResourceFactory.get({id: intermediateTemplateId}).$promise;
    };
    this.createIntermediateTemplate = (intermediateTemplate: JS5Object) => {
        return IntermediateTemplatesResourceFactory.save(intermediateTemplate).$promise;
    };
    this.cloneIntermediateTemplate = (intermediateTemplate: JS5Object) => {
        return IntermediateTemplatesResourceFactory.clone({id: intermediateTemplate.id}).$promise;
    };
    this.updateIntermediateTemplate = (intermediateTemplate: JS5Object) => {
        return IntermediateTemplatesResourceFactory.update(intermediateTemplate).$promise;
    };
    this.deleteIntermediateTemplate = (intermediateTemplateId: number) => {
        return IntermediateTemplatesResourceFactory.delete({id: intermediateTemplateId}).$promise;
    };
});
